import * as Animate from "react-reveal";
import { ArrowUpRight } from "../../../components/svgs";
import Avatar1 from "../../../assets/images/png/mba/mba-leader-woman-v1.png";
import Avatar2 from "../../../assets/images/png/bankole-adesina-v1.png";
import Avatar3 from "../../../assets/images/png/mba/mba-leader-man-v1.png";
import Avatar4 from "../../../assets/images/png/mba/mba-leader-hijab-v1.png";

const steps = [
  {
    number: "01",
    title: "Tell Us Who You Need",
    desc: "Role, experience, location, budget and expectations.",
    avatar: Avatar1,
  },
  {
    number: "02",
    title: "Access Assessed Talent",
    desc: "Utiva matches relevant professionals from the talent ecosystem.",
    avatar: Avatar2,
  },
  {
    number: "03",
    title: "Interview & Hire",
    desc: "Meet a focused shortlist and select the right person.",
    avatar: Avatar3,
  },
  {
    number: "04",
    title: "Run Everything Through Utiva",
    desc:
      "Contracts, onboarding, compliance, payroll and workforce operations continue in the same ecosystem.",
    avatar: Avatar4,
    tag: "INFRASTRUCTURE BEGINS →",
    soft: true,
  },
];

const HireProcessSection = () => {
  return (
    <section
      className="bg-hire-tint-blue py-16 md:py-20 lg:py-24 px-4"
      id="process"
    >
      <div className="container mx-auto">
        <div className="flex flex-wrap items-end justify-between gap-8 mb-12 lg:mb-14">
          <Animate.Fade bottom>
            <div className="max-w-xl">
              <p className="flex items-center font-poppins gap-3 text-primary text-sm font-extrabold tracking-widest uppercase mb-6">
                <span className="w-8 h-1 rounded-full bg-secondary inline-block"></span>
                How hiring works
              </p>
              <h2 className="text-3xl md:text-4xl leading-tight text-primary font-poppins font-bold mb-4 tracking-[-0.03em]">
                Four steps.{" "}
                <span className="text-primary">
                  The infrastructure continues.
                </span>
              </h2>
              <p className="text-gray text-base font-poppins leading-relaxed">
                Utiva does not disappear after the offer. That is where the
                operating layer begins.
              </p>
            </div>
          </Animate.Fade>

          <Animate.Fade bottom>
            <a
              href="https://app.utiva.co/signup?goal=employer"
              target="_blank"
              rel="noreferrer noopener"
              className="border border-primary text-primary font-poppins font-extrabold rounded-xl inline-flex items-center gap-4 px-5 py-4 custom-btn"
            >
              Start your request <ArrowUpRight className="w-3.5 h-3.5" />
            </a>
          </Animate.Fade>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
          {steps.map((step) => (
            <Animate.Fade bottom key={step.number}>
              <article
                className={`relative h-full flex flex-col border-t-4 border-secondary rounded-2xl p-7 ${
                  step.soft ? "bg-hire-tint-blue" : "bg-white"
                }`}
                style={{ minHeight: "280px" }}
              >
                <span className="font-poppins text-lg font-extrabold text-secondary">
                  {step.number}
                </span>
                <img
                  src={step.avatar}
                  alt=""
                  className="w-14 h-14 rounded-full object-cover border-2 border-white shadow-course-card mt-9"
                />
                <h3 className="font-poppins font-bold text-xl my-4 text-primary">
                  {step.title}
                </h3>
                <p className="font-poppins text-sm leading-relaxed m-0 text-gray">
                  {step.desc}
                </p>
                {step.tag && (
                  <b className="text-[#8b5a00] font-poppins text-xs font-extrabold mt-5">
                    {step.tag}
                  </b>
                )}
              </article>
            </Animate.Fade>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HireProcessSection;
